import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { TableContext } from 'Context/Table'
import StatusCell from './Components/StatusCell'
import { useAppStore } from 'Store/App'
import { useShippingStore } from 'Store/Shipping'
import { shallow } from 'zustand/shallow'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'

const ViewModel = () => {
  const { id, detailId } = useParams()
  const {
    // currentSorting,
    updateLoading,
    // updateError,
    updatePagination,
    updateSorting,
    resetState: resetTableState,
  } = useContext(TableContext)
  const setShowBackButton = useAppStore(state => state.setShowBackButton, shallow)

  const setupTable = () => {
    updateLoading(false)
    updatePagination(true)
    updateSorting('itemCode', false)
  }
  const { scanShipping, scanShippingAll } = useShippingStore(
    state => ({
      scanShipping: state.scanShipping,
      scanShippingAll: state.scanShippingAll,
    }),
    shallow
  )

  const { inventories, getInventories } = useShippingStore(
    state => ({
      inventories: state.inventories,
      getInventories: state.getInventories,
    }),
    shallow
  )

  const [scanCode, setScanCode] = useState('')
  const [isUseCamera, setIsUseCamera] = useState(false)
  const [hasCamera, setHasCamera] = useState(false)
  const handleSubmitScanCode = async (code: any) => {
    // alert(code)
    const { data, success } = await scanShipping(parseInt(detailId ?? ''), code)
    if (success) {
      setScanCode('')
      getInventories(parseInt(detailId ?? ''))
      toast.success('Scan Success')
    } else {
      toast.error(data)
      updateLoading(false)
      return
    }
  }

  useEffect(() => {
    async function checkCameraAvailability () {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices()
        setHasCamera(devices.some(device => device.kind === 'videoinput'))
      } catch (error) {
        console.error('Error checking camera availability:', error)
      }
    }

    checkCameraAvailability()
  }, [])

  const toggleUseCamera = () => {
    const nextValue = !isUseCamera
    if (!hasCamera) {
      toast.error('No camera found')
      return
    }
    setIsUseCamera(nextValue)
  }

  const handleScan = (scanData: any) => {
    if (scanData) {
      // setScanCode(scanData[0].rawValue);
      const code = scanData[0].rawValue.trim()
      Swal.fire({
        title: 'ยืนยันการสแกนขนส่งเสา?',
        text: `คุณสแกนรหัส: ${code}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
      }).then((result: any) => {
        // alert(result.isConfirmed);
        if (result.isConfirmed) {
          handleSubmitScanCode(code) // Pass result.value for data
        }
      })
    }
  }

  const handleScanAll = async () => {
    Swal.fire({
      title: 'ยืนยันการสแกนขนส่งเสาทั้งหมด?',
      text: `คุณต้องการสแกนขนส่งเสาทั้งหมดในคำขอขนส่งนี้`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result: any) => {
      // alert(result.isConfirmed);
      if (result.isConfirmed) {
        const { success, data } = await scanShippingAll(parseInt(detailId ?? ''))
        if (success) {
          getInventories(parseInt(detailId ?? ''))
          toast.success('Scan All Success')
        } else {
          toast.error(data)
          updateLoading(false)
          return
        }
      }
    })
  }

  const TABLE_CONFIGS: any[] = [
    {
      Header: 'อันดับ',
      accessor: 'sequence',
      width: 20,
      minWidth: 20,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    {
      Header: 'รหัสเสา',
      accessor: 'itemCode',

      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    {
      Header: 'code',
      accessor: 'inventoryCode',
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    {
      Header: 'Status',
      accessor: 'usageStatus',
      width: 100,
      minWidth: 100,
      Cell: ({ value }: any) => {
        return <StatusCell status={value} />
      },
    },
  ]

  useEffect(() => {
    setupTable()
    setShowBackButton(true)
    if (detailId) {
      getInventories(parseInt(detailId))
    }

    return () => {
      resetTableState()
      setShowBackButton(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    id,
    detailId,
    TABLE_CONFIGS,
    inventories,
    isUseCamera,
    scanCode,
    handleScan,
    handleScanAll,
    hasCamera,
    setScanCode,
    toggleUseCamera,
  }
}

export default ViewModel
